import moment from "moment";
import React, { useEffect, useState } from "react";
import { CustomerContactsState } from "src/types";

import LineChart from "../generic/LineChart";
import * as helpers from "./helpers";

interface Props {
  customerContacts: CustomerContactsState;
}

const CustomerContactsOfferAcceptedIfAddressedChart: React.FC<Props> = ({
  customerContacts,
}: Props) => {
  const [chartData, setChartData] = useState<Array<{ x: string; y1: number }>>(
    []
  );
  const [xTicks, setXTicks] = useState<string[]>([]);
  useEffect(() => {
    const convertToPercent = (val: number, compare: number) =>
      compare > 0 ? parseFloat(((100 * val) / compare).toFixed(1)) : 0;

    setChartData(
      customerContacts.countPerInterval.map((intervalCounts) => ({
        x: intervalCounts.date,
        y1: convertToPercent(
          intervalCounts.countOfferAccepted,
          intervalCounts.countOfferAddressed
        ),
        y2: convertToPercent(
          intervalCounts.countOfferAcceptedPersonalContact,
          intervalCounts.countOfferAddressedPersonalContact
        ),
        y3: convertToPercent(
          intervalCounts.countOfferAcceptedPhoneContact,
          intervalCounts.countOfferAddressedPhoneContact
        ),
      }))
    );
  }, [customerContacts]);

  useEffect(() => {
    if (chartData.length > 0) {
      setXTicks(helpers.getXDateTicks(chartData));
    }
  }, [chartData]);

  return (
    <LineChart
      chartId="offerAcceptedIfAddressed"
      data={chartData}
      height={350}
      xTickLabelsAngled
      xlabel="Monat"
      xAxisLabelOffset={35}
      xTickFormatter={(xValue) =>
        helpers.xTickFunction(xTicks, xValue as string)
      }
      tooltipXValueFormatter={(xVal) =>
        helpers.getWeekRangeStringForDate(xVal as string)
      }
      axisAllocation={{
        left: ["y1", "y2", "y3"],
      }}
      yValueFormatterAxisLeft={(tick) => `${tick} %`}
      ylabelAxisLeft="Anteil"
      curveLabels={{
        y1: "Alle",
        y2: "Persönlich",
        y3: "Telefonisch",
      }}
      averageLines={["y1"]}
      showCurveLegend
    />
  );
};

export default CustomerContactsOfferAcceptedIfAddressedChart;



// WEBPACK FOOTER //
// ./src/components/NbaEvaluation/CustomerContactsOfferAcceptedIfAddressedChart.tsx